import i18next from 'i18next';
import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable, DialogChoice} from 'web-app/react/dialog';

import OrganizationPerson from './model';
import * as Actions from './actions';
import * as Api from './api';

export const fetchObservable = (organizationId: string, organizationPersonId: string) =>
    Api.getOrganizationPerson(organizationId, organizationPersonId).map(data =>
        Actions.fetchSuccess.action(OrganizationPerson.fromAPI(data.organizationPerson)),
    );

export const fetchOrganizationPerson = action$ =>
    action$
        .ofType(Actions.fetch.type)
        .mergeMap(({payload}: ReturnType<typeof Actions.fetch.action>) =>
            fetchObservable(payload.organizationId, payload.organizationPersonId).catch(e =>
                Observable.of(Actions.fetchFailed.action(e)),
            ),
        );

const fetchOrganizationPersons = action$ =>
    action$.ofType(Actions.fetchAll.type).mergeMap(({payload}: ReturnType<typeof Actions.fetchAll.action>) =>
        Api.getOrganizationPersons(payload.organizationId)
            .map(data =>
                Actions.fetchAllSuccess.action(data.organizationPersons.map(p => OrganizationPerson.fromAPI(p))),
            )
            .catch(e => Observable.of(Actions.fetchAllFailed.action(e))),
    );

const createOrganizationPerson = action$ =>
    action$.ofType(Actions.create.type).mergeMap(({payload}: ReturnType<typeof Actions.create.action>) =>
        Api.createOrganizationPerson(payload.person.organizationId, OrganizationPerson.toAPI(payload.person))
            .map(newPersonData =>
                Actions.createSuccess.action(OrganizationPerson.fromAPI(newPersonData.organizationPerson)),
            )
            .catch(e => Observable.of(Actions.createFailed.action(e))),
    );

const updateOrganizationPerson = action$ =>
    action$.ofType(Actions.update.type).mergeMap(({payload}: ReturnType<typeof Actions.update.action>) =>
        Api.updateOrganizationPerson(
            payload.oldPerson.organizationId,
            payload.oldPerson.organizationPersonId,
            OrganizationPerson.toAPI(payload.newPerson),
        )
            .map(newPersonData =>
                Actions.updateSuccess.action(
                    payload.oldPerson,
                    OrganizationPerson.fromAPI(newPersonData.organizationPerson),
                ),
            )
            .catch(e => Observable.of(Actions.updateFailed.action(e))),
    );

const deleteOrganizationPerson = action$ =>
    action$.ofType(Actions.deletePerson.type).mergeMap(({payload}: ReturnType<typeof Actions.deletePerson.action>) =>
        showDeleteDialogObservable({
            title: i18next.t('organisationSettings.confirmDeleteHeader'),
            description: i18next.t('organisationSettings.confirmDelete'),
        }).mergeMap(selection => {
            if (selection === DialogChoice.OK) {
                return Api.deleteOrganizationPerson(payload.person.organizationId, payload.person.organizationPersonId)
                    .map(() => Actions.deletePersonSuccess.action(payload.person))
                    .catch(e => Observable.of(Actions.deletePersonFailed.action(e)));
            }
            return Observable.of(Actions.deletePersonAborted.action());
        }),
    );

export default combineEpics(
    fetchOrganizationPerson,
    fetchOrganizationPersons,
    createOrganizationPerson,
    updateOrganizationPerson,
    deleteOrganizationPerson,
);
